import { ieval } from "./common.js";
import { after, NodeRange } from "./noderange.js";
import { morph } from "./morph.js";
import { render } from "./render.js";

export const psatina = (
  template: HTMLTemplateElement,
  dataExpr: string,
  targetRange: NodeRange = after(template),
) => {
  let data = ieval(dataExpr, template)
  ~(data.update = async (f?: () => unknown) => {
    await f?.()
    morph(targetRange, render(template.content, data))
  })()  
}

document.querySelectorAll<HTMLTemplateElement>('template[p\\:data]').forEach(n =>
  psatina(n, n.getAttribute('p:data') || '{}'))
